export enum Variant {
  Spinner = "spinner",
  Wheel = "wheel",
}
